// extracted by mini-css-extract-plugin
export default {"page":"MultiBrand_page__-b-sV","body":"MultiBrand_body__KnFtu","brands":"MultiBrand_brands__3TMAD","info":"MultiBrand_info__4Kzf2"};